import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { ContentElement, FontSizeClasses, GridCell, HeadFootEnum, RowCell } from '@urbannex/storethemes';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

export const enum LastActionEnum {
  INIT = "INIT",
  BG_SET = "BackgroundSet",
  IMAGE_SET = "ImageSet",
  LAYOUT_SET = "LayoutSet",
  THEME_SET = "ThemeSet",
  CONTENT_SET = "ContentSet"
}

export interface GridCellState {
  activeSelector?: any;
  imgSrc?: string;
  layoutClass?: string;
  bgColor?: string;
  fillClass?: string;
  fillColor?: string;
  theme?: string;
  imageChosen?: boolean;
  headerTextColor?: string;
  headerClass?: string;
  footerTextColor?: string;
  textColor?: string;
  headerFntSze?: string;
  footerFntSze?: string;
  textFntSze?: string;
  heightClass?: string;
  widthClass?: string;

  contentElements?: ContentElement[];
  selectedContentElement?: ContentElement;

  hdrFontSizeClass?: FontSizeClasses;
  ftrFontSizeClass?: string;
  txtFontSizeClass?: string;

  hdrFontFam?: string;
  ftrFontFam?: string;
  txtFontFam?: string;

  hdrWeightClass?: string;
  ftrWeightClass?: string;
  txtWeightClass?: string;

  // Container Background
  hdrContBgClr?: string;
  ftrContBgClr?: string;
  txtContBgClr?: string;

  // Container Layout Classes
  hdrContLayoutClass?: string;
  ftrContLayoutClass?: string;
  txtContLayoutClass?: string;

  // Container Padding

  // Parent
  hdrParBgColor?: string;
  ftrParBgColor?: string;
  txtParBgColor?: string;

  // Borders
  hdrBorderWdtCls?: string;
  ftrBorderWdtCls?: string;
  txtBorderWdtCls?: string;

  hdrBorderRdsCls?: string;
  ftrBorderRdsCls?: string;
  txtBorderRdsCls?: string;

  hdrBorderColr?: string;
  ftrBorderColr?: string;
  txtBorderColr?: string;
  // Padding
  hdrPadCls?: string;
  ftrPadCls?: string;
  txtPadCls?: string;

  hdrParPadCls?: string;
  ftrParPadCls?: string;
  txtParPadCls?: string;

  hdrPadCust?: string;
  ftrPadCust?: string;
  txtPadCust?: string;

  hdrParPadCust?: string;
  ftrParPadCust?: string;
  txtParPadCust?: string;

  // Alignmnet
  hdrAlign?: string;
  txtAlign?: string;
  ftrAlign?: string;


  selectedCell?: GridCell | RowCell;
  headerFooterState?: HeadFootEnum;
  lastActionState?: LastActionEnum;
  selectorPosChange?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CellEditorStoreService extends ComponentStore<GridCellState> {

  constructor() {
    super({ imgSrc: undefined, layoutClass: "cell-layout-default", theme: "cell-theme-default", imageChosen: false, lastActionState: LastActionEnum.INIT })
  }

  init(selectedCell: GridCell | RowCell, imgSrc?: string, layoutClass?: string, theme?: string, headerFooterOpt?: HeadFootEnum) {
    this.updateSelectedCell({});
    console.log("Running init again ... ", selectedCell)
    this.updateSelectedCell(selectedCell);
    // this.updateImgSrc(imgSrc);
    // this.updateLayoutClass(layoutClass);
    this.updateTheme(theme);
    // this.updateHeaderFooterEnum(headerFooterOpt),
    this.updateContentElements(selectedCell.contentElements);
    this.setActiveSelector(selectedCell.contentElements);
    this.updateLastActionState(LastActionEnum.INIT);
    this.updateSelectorPosChange("init")
  }
  // updaters
  readonly updateContentElements = this.updater((state: GridCellState, contentElements: ContentElement[]) => {
    console.log("Updated contentElements ....");
    console.log(contentElements);
    return {
      ...state,
      contentElements: contentElements
    }
  })
  readonly updateActiveSelector = this.updater((state: GridCellState, selector: any) => {
    console.log(selector)
    return {
      ...state,
      activeSelector: selector
    }
  })
  /**
   * Updates the selectedCell imgSrc prorerty and the selectedCell in the state
   */
  readonly updateSelectedCellImgSrc = this.updater((state: GridCellState, imgSrc: string) => {
    console.log({ TrackUpdateSelectedCellImgSrc: imgSrc })
    // Update the corresponding content element in selectedCell
    let newSelectedCell = state.selectedCell;
    newSelectedCell = {
      ...state.selectedCell,
      imgSrc: imgSrc
    }
    return {
      ...state,
      selectedCell: newSelectedCell
    };

  })
  /**
   * Update a contentElement and the selectedCell it belongs to
   */
  readonly updateActiveSelectorAndSelectedCell = this.updater((state: GridCellState, updatedContentElement: ContentElement) => {
    // Update activeSelector
    const newActiveSelector = updatedContentElement;

    // Update the corresponding content element in selectedCell
    let newSelectedCell = state.selectedCell;

    if (state.selectedCell && state.selectedCell.contentElements) {
      const updatedContentElements = state.selectedCell.contentElements.map(element =>
        element.elId === updatedContentElement.elId ? updatedContentElement : element
      );

      newSelectedCell = {
        ...state.selectedCell,
        contentElements: updatedContentElements
      };
    }

    return {
      ...state,
      activeSelector: newActiveSelector,
      selectedCell: newSelectedCell
    };
  });
  readonly updateSelectorPosChange = this.updater((state: GridCellState, positionChange: string) => {
    return {
      ...state,
      selectorPosChange: positionChange
    }
  })
  readonly updateSelectedCell = this.updater((state: GridCellState, selectedCell: GridCell | RowCell) => {
    console.log(selectedCell)
    return {
      ...state,
      selectedCell: selectedCell
    }
  })
  readonly updateLastActionState = this.updater((state: GridCellState, lastAction: LastActionEnum) => {
    return {
      ...state,
      lastActionState: lastAction
    }
  })
  readonly updateImgSrc = this.updater((state: GridCellState, imgSrc: string) => {
    const updatedCell = state.selectedCell ? { ...state.selectedCell, imgSrc } : undefined;
    console.log("SelectedCell after imgSrc update", updatedCell);
    return {
      ...state,
      imgSrc: imgSrc,
      selectedCell: updatedCell
    };
  })

  readonly updateLayoutClass = this.updater((state: GridCellState, layoutClass: string) => {
    this.selectedCell$.subscribe(selectedCell => {
      selectedCell.layoutClass = layoutClass;
      this.updateSelectedCell(selectedCell);
    })
    return {
      ...state,
      layoutClass: layoutClass
    }
  })

  readonly updateTheme = this.updater((state: GridCellState, theme: string) => {
    return {
      ...state,
      theme: theme
    }
  })

  readonly updateImageChosen = this.updater((state: GridCellState, imageChosen: boolean) => {
    return {
      ...state,
      imageChosen: imageChosen
    }
  })

  readonly updateHeaderFooterEnum = this.updater((state: GridCellState, headerFooterEnum: HeadFootEnum) => {
    return {
      ...state,
      headerFooterState: headerFooterEnum
    }
  })

  readonly updateBgColor = this.updater((state: GridCellState, bgColor: string) => {
    return {
      ...state,
      bgColor: bgColor
    }
  })

  readonly updateFillClass = this.updater((state: GridCellState, fillClass: string) => {
    this.selectedCell$.subscribe(selectedCell => {
      selectedCell.fillClass = fillClass;
      this.updateSelectedCell(selectedCell);
    })
    return {
      ...state,
      fillClass: fillClass
    }
  })
  readonly updateFillColor = this.updater((state: GridCellState, fillColor: string) => {
    this.selectedCell$.subscribe(selectedCell => {
      selectedCell.fillColor = fillColor;
      this.updateSelectedCell(selectedCell);
    })
    return {
      ...state,
      fillColor: fillColor
    }
  })
  readonly updateTxtColor = this.updater((state: GridCellState, txtClr: string) => {
    return {
      ...state,
      textColor: txtClr
    }
  })
  readonly updateHeaderTxtColor = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      headerTextColor: color
    }
  })
  readonly updateFooterTxtColor = this.updater((state: GridCellState, footerTxtClr: string) => {
    return {
      ...state,
      footerTextColor: footerTxtClr
    }
  })

  readonly updateHdrFontSze = this.updater((state: GridCellState, headerFntSze: FontSizeClasses) => {
    return {
      ...state,
      hdrFontSizeClass: headerFntSze
    }
  })
  readonly updateFtrFontSze = this.updater((state: GridCellState, footerFntSze: string) => {
    return {
      ...state,
      footerFntSze: footerFntSze
    }
  })
  readonly updateTxtFontSze = this.updater((state: GridCellState, textFntSze: string) => {
    console.log(textFntSze);
    return {
      ...state,
      textFntSze: textFntSze
    }
  })

  readonly updateHdrClass = this.updater((state: GridCellState, hdrCls: string) => {
    return {
      ...state,
      headerClass: hdrCls
    }
  })
  readonly updateHgthClass = this.updater((state: GridCellState, hghtClass: string) => {
    this.selectedCell$.subscribe(selectedCell => {
      selectedCell.heightCls = hghtClass;
      this.updateSelectedCell(selectedCell);
    })
    return {
      ...state,
      heightClass: hghtClass
    }
  })
  readonly updateWdthClass = this.updater((state: GridCellState, widthCls: string) => {
    return {
      ...state,
      widthClass: widthCls
    }
  })

  readonly updateHdrFontSize = this.updater((state: GridCellState, fontSizeCls: string) => {
    return {
      ...state,
      headerFntSze: fontSizeCls
    }
  })
  readonly updateFtrFontSize = this.updater((state: GridCellState, fontSizeCls: string) => {
    return {
      ...state,
      footerFntSze: fontSizeCls
    }
  })
  readonly updateFtrFontSzeClass = this.updater((state: GridCellState, fontSizeCls: string) => {
    return {
      ...state,
      ftrFontSizeClass: fontSizeCls
    }
  })
  readonly updateTxtFontSize = this.updater((state: GridCellState, fontSizeCls: string) => {
    return {
      ...state,
      textFntSze: fontSizeCls
    }
  })
  readonly updateHdrFontFam = this.updater((state: GridCellState, fontFam: string) => {
    return {
      ...state,
      hdrFontFam: fontFam
    }
  })

  readonly updateFtrFontFam = this.updater((state: GridCellState, fontFam: string) => {
    return {
      ...state,
      ftrFontFam: fontFam
    }
  })

  readonly updateTxtFontFam = this.updater((state: GridCellState, fontFam: string) => {
    return {
      ...state,
      txtFontFam: fontFam
    }
  })

  readonly updateHdrWeightCls = this.updater((state: GridCellState, weightCls: string) => {
    return {
      ...state,
      hdrWeightClass: weightCls
    }
  })
  readonly updateFtrWeightCls = this.updater((state: GridCellState, weightCls: string) => {
    return {
      ...state,
      ftrWeightClass: weightCls
    }
  })
  readonly updateTxtWeightCls = this.updater((state: GridCellState, weightCls: string) => {
    return {
      ...state,
      txtWeightClass: weightCls
    }
  })
  // Container updaters
  readonly updateHdrContBgClr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      hdrContBgClr: color
    }
  })
  readonly updateFtrContBgClr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      ftrContBgClr: color
    }
  })
  readonly updateTxtContBgClr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      txtContBgClr: color
    }
  })

  readonly updateHdrContLayoutClass = this.updater((state: GridCellState, layoutClass: string) => {
    return {
      ...state,
      hdrContLayoutClass: layoutClass
    }
  })
  readonly updateFtrContLayoutClass = this.updater((state: GridCellState, layoutClass: string) => {
    return {
      ...state,
      ftrContLayoutClass: layoutClass
    }
  })
  readonly updateTxtContLayoutClass = this.updater((state: GridCellState, layoutClass: string) => {
    return {
      ...state,
      txtContLayoutClass: layoutClass
    }
  })

  // Border updaters
  readonly updateHdrBorderWdtCls = this.updater((state: GridCellState, wdtClass: string) => {
    return {
      ...state,
      hdrBorderWdtCls: wdtClass
    }
  })
  readonly updateFtrBorderWdtCls = this.updater((state: GridCellState, wdtClass: string) => {
    return {
      ...state,
      ftrBorderWdtCls: wdtClass
    }
  })
  readonly updateTxtBorderWdtCls = this.updater((state: GridCellState, wdtClass: string) => {
    return {
      ...state,
      txtBorderWdtCls: wdtClass
    }
  })

  readonly updateHdrBorderRdsCls = this.updater((state: GridCellState, rdsClass: string) => {
    return {
      ...state,
      hdrBorderRdsCls: rdsClass
    }
  })
  readonly updateFtrBorderRdsCls = this.updater((state: GridCellState, rdsClass: string) => {
    return {
      ...state,
      ftrBorderRdsCls: rdsClass
    }
  })
  readonly updateTxtBorderRdsCls = this.updater((state: GridCellState, rdsClass: string) => {
    return {
      ...state,
      txtBorderRdsCls: rdsClass
    }
  })

  readonly updateHdrBorderColr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      hdrBorderColr: color
    }
  })
  readonly updateFtrBorderColr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      ftrBorderColr: color
    }
  })
  readonly updateTxtBorderColr = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      txtBorderColr: color
    }
  })

  // Parent updaters
  readonly updateHdrParBgColor = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      hdrParBgColor: color
    }
  })
  readonly updateFtrParBgColor = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      ftrParBgColor: color
    }
  })
  readonly updateTxtParBgColor = this.updater((state: GridCellState, color: string) => {
    return {
      ...state,
      txtParBgColor: color
    }
  })

  // Padding Updaters
  readonly updateHdrPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      hdrPadCls: padClass
    }
  })
  readonly updateFtrPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      ftrPadCls: padClass
    }
  })
  readonly updateTxtPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      txtPadCls: padClass
    }
  })

  readonly updateHdrParPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      hdrParPadCls: padClass
    }
  })
  readonly updateFtrParPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      ftrParPadCls: padClass
    }
  })
  readonly updateTxtParPadCls = this.updater((state: GridCellState, padClass: string) => {
    return {
      ...state,
      txtParPadCls: padClass
    }
  })

  readonly updateHdrPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      hdrPadCust: padding
    }
  })
  readonly updateFtrPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      ftrPadCust: padding
    }
  })
  readonly updateTxtPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      txtPadCust: padding
    }
  })

  readonly updateHdrParPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      hdrParPadCust: padding
    }
  })
  readonly updateFtrParPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      ftrParPadCust: padding
    }
  })
  readonly updateTxtParPadCust = this.updater((state: GridCellState, padding: string) => {
    return {
      ...state,
      txtParPadCust: padding
    }
  })

  // Alignment Updates
  readonly updateHdrAlign = this.updater((state: GridCellState, alignmnt: string) => {
    return {
      ...state,
      hdrAlign: alignmnt
    }
  })
  readonly updateTxtAlign = this.updater((state: GridCellState, alignmnt: string) => {
    return {
      ...state,
      txtAlign: alignmnt
    }
  })
  readonly updateFtrAlign = this.updater((state: GridCellState, alignmnt: string) => {
    return {
      ...state,
      ftrAlign: alignmnt
    }
  })




  // selectors
  readonly contentElements$: Observable<ContentElement[]> = this.select(state => state.contentElements);
  readonly activeSelector$: Observable<any> = this.select(state => state.activeSelector);
  readonly selectedCell$: Observable<GridCell | RowCell> = this.select(state => state.selectedCell);
  readonly lastActionState$: Observable<LastActionEnum> = this.select(state => state.lastActionState);
  readonly selectorPosChange$: Observable<string> = this.select(state => state.selectorPosChange);
  readonly imgSrc$: Observable<string> = this.select(state => state.imgSrc);
  readonly layoutClass$: Observable<string> = this.select(state => state.layoutClass);
  readonly theme$: Observable<string> = this.select(state => state.theme);
  readonly imageChosen$: Observable<boolean> = this.select(state => state.imageChosen);
  readonly headerFooterOption$: Observable<HeadFootEnum> = this.select(state => state.headerFooterState);
  readonly bgColor$: Observable<string> = this.select(state => state.selectedCell.bgColor);
  readonly fillColor$: Observable<string> = this.select(state => state.selectedCell.fillColor);
  readonly fillClass$: Observable<string> = this.select(state => state.selectedCell.fillClass);
  readonly txtClr$: Observable<string> = this.select(state => state.textColor);
  readonly headerTxtClr$: Observable<string> = this.select(state => state.headerTextColor);
  readonly footerTxtClr$: Observable<string> = this.select(state => state.footerTextColor);
  readonly headerFntSze$: Observable<string> = this.select(state => state.headerFntSze);
  readonly footerFntSze$: Observable<string> = this.select(state => state.footerFntSze);
  readonly textFntSze$: Observable<string> = this.select(state => state.textFntSze);
  readonly headerCls$: Observable<string> = this.select(state => state.headerClass);
  readonly heightClass$: Observable<string> = this.select(state => state.heightClass);
  readonly widthClass$: Observable<string> = this.select(state => state.widthClass);

  readonly hdrFontSize$: Observable<string> = this.select(state => state.hdrFontSizeClass);
  readonly ftrFontSizeClass$: Observable<string> = this.select(state => state.ftrFontSizeClass);
  readonly txtFontSize$: Observable<string> = this.select(state => state.txtFontSizeClass);
  readonly hdrFontFam$: Observable<string> = this.select(state => state.hdrFontFam);
  readonly ftrFontFam$: Observable<string> = this.select(state => state.ftrFontFam);
  readonly txtFontFam$: Observable<string> = this.select(state => state.txtFontFam);

  readonly hdrWeight$: Observable<string> = this.select(state => state.hdrWeightClass);
  readonly ftrWeight$: Observable<string> = this.select(state => state.ftrWeightClass);
  readonly txtWeight$: Observable<string> = this.select(state => state.txtWeightClass);

  // Container Selectors
  readonly hdrContBgClr$: Observable<string> = this.select(state => state.hdrContBgClr);
  readonly ftrContBgClr$: Observable<string> = this.select(state => state.ftrContBgClr);
  readonly txtContBgClr$: Observable<string> = this.select(state => state.txtContBgClr);
  readonly hdrContLayoutClass$: Observable<string> = this.select(state => state.hdrContLayoutClass);
  readonly ftrContLayoutClass$: Observable<string> = this.select(state => state.ftrContLayoutClass);
  readonly txtContLayoutClass$: Observable<string> = this.select(state => state.txtContLayoutClass);

  // Parent Selectors
  readonly hdrParBgColor$: Observable<string> = this.select(state => state.hdrParBgColor);
  readonly ftrParBgColor$: Observable<string> = this.select(state => state.ftrParBgColor);
  readonly txtParBgColor$: Observable<string> = this.select(state => state.txtParBgColor);

  // Border Selectors
  readonly hdrBorderWdtCls$: Observable<string> = this.select(state => state.hdrBorderWdtCls);
  readonly ftrBorderWdtCls$: Observable<string> = this.select(state => state.ftrBorderWdtCls);
  readonly txtBorderWdtCls$: Observable<string> = this.select(state => state.txtBorderWdtCls);

  readonly hdrBorderRdsCls$: Observable<string> = this.select(state => state.hdrBorderRdsCls);
  readonly ftrBorderRdsCls$: Observable<string> = this.select(state => state.ftrBorderRdsCls);
  readonly txtBorderRdsCls$: Observable<string> = this.select(state => state.txtBorderRdsCls);

  readonly hdrBorderColr$: Observable<string> = this.select(state => state.hdrBorderColr);
  readonly ftrBorderColr$: Observable<string> = this.select(state => state.ftrBorderColr);
  readonly txtBorderColr$: Observable<string> = this.select(state => state.txtBorderColr);

  // Padding Selector
  readonly hdrPadCls$: Observable<string> = this.select(state => state.hdrPadCls);
  readonly ftrPadCls$: Observable<string> = this.select(state => state.ftrPadCls);
  readonly txtPadCls$: Observable<string> = this.select(state => state.txtPadCls);

  readonly hdrParPadCls$: Observable<string> = this.select(state => state.hdrParPadCls);
  readonly ftrParPadCls$: Observable<string> = this.select(state => state.ftrParPadCls);
  readonly txtParPadCls$: Observable<string> = this.select(state => state.txtParPadCls);

  readonly hdrPadCust$: Observable<string> = this.select(state => state.hdrPadCust);
  readonly ftrPadCust$: Observable<string> = this.select(state => state.ftrPadCust);
  readonly txtPadCust$: Observable<string> = this.select(state => state.txtPadCust);

  readonly hdrParPadCust$: Observable<string> = this.select(state => state.hdrParPadCust);
  readonly ftrParPadCust$: Observable<string> = this.select(state => state.ftrParPadCust);
  readonly txtParPadCust$: Observable<string> = this.select(state => state.txtParPadCust);

  // Alignment Updaters
  readonly hdrAlign$: Observable<string> = this.select(state => state.hdrAlign);
  readonly txtAlign$: Observable<string> = this.select(state => state.txtAlign);
  readonly ftrAlign$: Observable<string> = this.select(state => state.ftrAlign);

  readonly cellState$: Observable<GridCellState> = this.select(state => state);

  readonly contentWidth$: Observable<string> = this.select(state => state.selectedCell.contentWidth);
  readonly cellTextColor$: Observable<string> = this.select(state => state.selectedCell.color);
  readonly cellVerticalAlign$: Observable<string> = this.select(state => state.selectedCell.cellVerticalAlign);
  readonly cellHorizontalAlign$: Observable<string> = this.select(state => state.selectedCell.cellHorizontalAlign);
  readonly cellBgColor$: Observable<string> = this.select(state => state.selectedCell.bgColor);
  // effects
  readonly setActiveSelector = this.effect<ContentElement[]>((contentElements$) =>
    contentElements$.pipe(
      filter((contentElements) => contentElements && contentElements.length > 0),
      tap((contentElements) => {
        this.updateActiveSelector(contentElements[0]);
      })
    )
  );
  readonly setHeader = this.effect((headerText$: Observable<string>) => {
    return headerText$.pipe(
      tap((headerText: string) => {
        this.selectedCell$.subscribe((selectedCell: GridCell | RowCell) => {
          selectedCell.heading.headerText = headerText;
          this.updateSelectedCell(selectedCell);
        })
      })
    )
  })

  readonly setFooter = this.effect((footerText$: Observable<string>) => {
    return footerText$.pipe(
      tap((footerText: string) => {
        this.selectedCell$.subscribe((selectedCell: GridCell | RowCell) => {
          selectedCell.footer.footerText = footerText;
          this.updateSelectedCell(selectedCell);
        })
      })
    )
  })


}
